import styled from 'styled-components';

import UnstyledContainer from '../common/container';

export const Content = styled.div`
  margin: 0 20px;
  
`;

export const Container = styled(UnstyledContainer)`
  margin: 100px auto;
`;

export const Headline = styled.h2`
  margin: 0;
`;
